import React from "react";
import { useSelector } from "react-redux";
import { useTheme, useMediaQuery } from "@mui/material";

const ScreenContainer = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.user);
  const theme = useTheme();

  // Detect breakpoints
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg")); // ≥1200px
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg")); // 900px - 1200px
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // <900px

  let containerWidth = "100%";

  if (isDesktop) {
    containerWidth = isAuthenticated ? "100%" : "85%";
  } else if (isLaptop) {
    containerWidth = "95%";
  } else if (isMobile) {
    containerWidth = "100%";
  }

  return (
    <div
      style={{
        width: containerWidth,
        margin: "0 auto",
        padding:isMobile ?"0 10px" : "0",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      {children}
    </div>
  );
};

export default ScreenContainer;
